export const routes = {
  Root: "/",
  Login: "/login",
  MyParties: "/my-parties",
  MyPartyWithId: (id: string) => `/my-party/${id}`,
  RequestClub: (groupId: string) => `/my-party/${groupId}/request-club/`,
  PromotersMode: "/promoters-mode",
  MissingClub: "/make-offer/:groupId/missing-clubs",
  OfferDetails: (partyId: string, offerId: string) =>
    `/my-party/${partyId}/offers/${offerId}`,
  PromGroupDetailPage: (city: string, groupId: string) => `/promoter-group-detail/${city}/${groupId}`,
  PromoterOfferDetails: (city: string, groupId: string, offerId: string) => `/promoter-group-detail/${city}/${groupId}/offers/${offerId}`,
  PromGroupPhotosPage: (city: string, groupId: string) => `/promoter-group-photo/${city}/${groupId}`,
  AlsoGoingOutDetailPage: (groupId: string) => `/alsoGoingOutGroupDetail/${groupId}`,
  ChatPages: "/chat",
  GuestMode: "/guest-mode",
  MakeOffer: (city: string | undefined, groupId: string) => `/make-offer/${city}/${groupId}`,
  CitySelector: "/city-selector",
  UserProfile: "/user-profile",
  EditProfile: "/edit-profile",
  PhotoZoom: (callBackUrl: string, city: string, groupId: string, photoId: string) => `/${callBackUrl}/${city}/${groupId}/photoZoom/${photoId}`,
  InvitedFriendInfo: (groupId: string, friendId: string) => `/my-party/${groupId}/invited-friend-info/${friendId}`,
};
